import UAParser from 'ua-parser-js';

const uaParser = new UAParser();

export default uaParser;
